import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path fill="currentColor" d="m10 20-4-4 1-2 2 2v-4h2v4l2-2 1 2-4 4Zm-6-6-4-4 4-4 2 1-2 2h4v2H4l2 2-2 1Zm12 0-2-1 2-2h-4V9h4l-2-2 2-1 4 4-4 4ZM9 8V4L7 6 6 4l4-4 4 4-1 2-2-2v4H9Z"/>',
  f: '<path fill="currentColor" d="m10 20-4-4 1-2 2 2v-4h2v4l2-2 1 2-4 4Zm-6-6-4-4 4-4 2 1-2 2h4v2H4l2 2-2 1Zm12 0-2-1 2-2h-4V9h4l-2-2 2-1 4 4-4 4ZM9 8V4L7 6 6 4l4-4 4 4-1 2-2-2v4H9Z"/>',
  vb: '-1 -1 22 22',
  rao: { fill: 'none' },
  raf: { fill: 'none' },
};

export default data;
